import Plant from '@icons/Plant.jsx'

const OrganicTag = () => {
    return (
        <div className="organic-tag-outer mt-1">
            <div className="organic-tag-inner flex flex-row gap-x-1 items-center">
                <Plant width="w-[17px]" />{' '}
                <div>
                    <span className="organic-tag-text text-sm font-normal">
                        Organic
                    </span>
                </div>
            </div>
        </div>
    )
}
export default OrganicTag
